var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 90,
    viewBox: "0 0 43 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 87.67H0M24.75 81.08H0M24.75 74.49H0M24.75 67.9H0M24.75 61.31H0M24.75 54.72H0M24.75 48.13H0M24.75 41.54H0M24.75 34.95H0M24.75 28.36H0M24.75 21.77H0M24.75 15.18H0M24.75 8.59H0M24.75 2H0",
    stroke: "#E71F74",
    strokeWidth: 1.46,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.04 87.67H22M42.04 81.08H22M42.04 74.49H22M42.04 67.9H22M42.04 61.31H22M42.04 54.72H22M42.04 48.13H22M42.04 41.54H22M42.04 34.95H22M42.04 28.36H22M42.04 21.77H22M42.04 15.18H22M42.04 8.59H22M42.04 2H22",
    stroke: "#E71F74",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.3645618fbb57b275c5ada6371f129818.svg";
export { ForwardRef as ReactComponent };